// /src/pages/admin/EditArtworkPage.tsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

// Firebase services
import { getArtworkById, updateArtwork } from "../../lib/firebase/firestore";

// Types
import { Artwork } from "../../types";

export const EditArtworkPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [artwork, setArtwork] = useState<Artwork | null>(null);
  const [loading, setLoading] = useState(false);

  // Load artwork on mount
  useEffect(() => {
    const loadArtwork = async () => {
      if (!id) return;
      const data = await getArtworkById(id);
      if (data) {
        setArtwork(data);
      }
    };
    loadArtwork();
  }, [id]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setArtwork((prev) => prev && { ...prev, [name]: value });
  };

  const handleTagChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const tags = e.target.value.split(",").map((t) => t.trim());
    setArtwork((prev) => prev && { ...prev, tags });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!artwork || !artwork.imageUrl)
      return alert("Please enter an image URL");

    setLoading(true);

    try {
      await updateArtwork(id!, {
        title: artwork.title,
        description: artwork.description,
        imageUrl: artwork.imageUrl,
        tags: artwork.tags,
        year: parseInt(artwork.year as unknown as string),
      });

      alert("Artwork updated successfully!");
      navigate("/admin/artworks");
    } catch (error) {
      console.error("Error updating artwork:", error);
      alert("Failed to update artwork");
    }

    setLoading(false);
  };

  if (!artwork) return <div>Loading...</div>;

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Edit Artwork</h2>
      <form onSubmit={handleSubmit}>
        {/* Title */}
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={artwork.title}
          onChange={handleChange}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        {/* Description */}
        <textarea
          name="description"
          placeholder="Description"
          value={artwork.description}
          onChange={handleChange}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        {/* Tags */}
        <input
          type="text"
          name="tags"
          placeholder="Tags (comma-separated)"
          value={artwork.tags.join(", ")}
          onChange={handleTagChange}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        {/* Year */}
        <input
          type="number"
          name="year"
          placeholder="Year"
          value={artwork.year}
          onChange={handleChange}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        {/* Image URL */}
        <input
          type="url"
          name="imageUrl"
          placeholder="Image URL"
          value={artwork.imageUrl}
          onChange={handleChange}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "0.75rem",
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          {loading ? "Saving..." : "Update Artwork"}
        </button>
      </form>
    </div>
  );
};
